<div class="sku-panel" *ngIf="selectedSkus.length > 1">
  <ng-container>
    <ng-template
      [cdkPortalOutlet]="selectedPortal"
      (attached)="attach($event)"
    ></ng-template>
  </ng-container>
</div>
